import { SvgIconBase, } from "./Base";


export const ChevronLeftStroke = () => {
	return (
		<SvgIconBase width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-label="Chevron Left Stroke" fill="none">
			<title>Chevron Left Stroke</title>
			<path
				d="M15.5996 18.957L9.59961 12.957L15.5996 6.95703"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SvgIconBase>
	);
};

